<template>
    <div>
        <v-row>
            <v-col cols="5"><v-img contain width="48" class="PreviewLogoCropped" :src="catLogoData"></v-img></v-col>
            <v-col cols="7" style="display: flex;justify-content: flex-end;">
                <input accept="image/png,image/jpg,image/jpeg,image/gif" @change="catLogoSelectedEvt($event)" type="file" ref="catLogoSelectorRef" style="display:none"/>
                <v-btn outlined dark color="#7600b3" @click="$refs.catLogoSelectorRef.click()"><v-icon small style="padding-left:5px;">fa fa-image</v-icon>&nbsp; {{Title}}</v-btn>
            </v-col>
        </v-row>
        <v-dialog max-width="600" style="overflow: hidden !important;" persistent v-model="catLogoSelectionDialog">
            <v-card>
                <v-card-title style="padding:0px !important">
                    <v-app-bar dense color="rgb(42, 45, 69)" dark>
                        <v-toolbar-title style="color:orange">برش عکس</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="orange" @click="catLogoSelectionDialog = false" small>fa fa-times</v-icon>
                    </v-app-bar>
                </v-card-title>
                <v-card-text style="padding-top:10px;">
                    <!-- <v-alert dense type="info" outlined>
                        <div>کاربر گرامی ؛ </div>
                        <div>اندازه عکس دسته بندی بهتر است به صورت زیر باشد :</div>
                        <div>کمینه عرض : {{ALLOEWDIMGSIZE.minwidth}} پیکسل</div>
                        <div>بیشینه عرض : {{ALLOEWDIMGSIZE.maxwidth}} پیکسل</div>
                        <div>کمینه ارتفاع : {{ALLOEWDIMGSIZE.minheight}} پیکسل</div>
                        <div>بیشینه ارتفاع : {{ALLOEWDIMGSIZE.maxheight}} پیکسل</div>
                        <div>نسبت عرض به ارتفاع : {{ALLOEWDIMGSIZE.aspectratio}}</div>
                    </v-alert> -->
                    <div class="overFlowHidden">
                        <cropper previewClassname="PreviewLogoCropped" maxWidth="400" maxHeight="400" classname="cropper" :src="selectedLogoSource"  @change="change"></cropper>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn @click="$refs.catLogoSelectorRef.click()" outlined dark color="red"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp;  عکس جدید</v-btn>&nbsp;
                    <v-btn outlined dark color="blue" @click="uploadEntityLogo"><v-icon small style="padding-left:5px;">fa fa-upload</v-icon>&nbsp; آپلود</v-btn>&nbsp;
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    
</template>
<script>
const axios = require("axios");
const ApiUrl = require('../../constant/apiurl');
const MSGHNDL = require('../../constant/MessageHandler');
const FTYPES = require('../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../constant/setting/Default/AllowedFileSize');
export default {
    name:"InternalCropper",
    props:{
        Url:{type:String},
        Flag:{type:String},
        Title:{type:String,default:"لوگو"}
    },
    data:()=>({
        selectedLogoSource: '',
        catLogoData:"",
        catLogoSelectionDialog:false,
        ALLOEWDIMGSIZE:{},
        ImagName:""
    }),
    created()
    {
        this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    },
    methods:{
        async uploadEntityLogo() {
        let vm = this;
        await axios
            .post(vm.Url, {
            DataUrl: vm.catLogoData,
            Loc: vm.Flag,
            })
            .then((res) => {
            if (res.data.status) {
                MSGHNDL.OK(res.data.msg);
                vm.ImagName = res.data.data;
                vm.catLogoSelectionDialog = false;
                vm.Emmit();
            } else {
                MSGHNDL.ERR(res.data.msg);
            }
            })
            .catch((err) => {
            console.error(err);
            });
        },
        Emmit()
        {
            let vm =this;
            vm.$emit("ImageUploaded",vm.ImagName)
        },
        catLogoSelectedEvt(e)
        {
            let vm = this;
            let file = e.target.files[0];
            if(FTYPES.PRDCATLOGOFILETYPES.indexOf(file.type) == -1)
            {
                MSGHNDL.ERRFILEFORMAT();
                e.preventDefault();
                return;
            }
            if(file.size > 2000000)
            {
                MSGHNDL.ERRFILESIZE("2 مگابایت ");
                e.preventDefault();
                return;
            }
            MSGHNDL.CHKIMAGESIZE(file,0,0,0,0,1);
            
            if (FileReader) {
                var fr = new FileReader();
                fr.onload = function () {
                    vm.selectedLogoSource = fr.result;
                    vm.catLogoSelectionDialog = true;
                }
                fr.readAsDataURL(file);
            }
        },
        change({coordinates, canvas}) {
           this.catLogoData = canvas.toDataURL();
        },
    }
}
</script>